import React from 'react'
import { H1 } from '@/common/ui'
import { APP } from '@/common/strings'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { REWARDS_COPY } from '@/locales/en'
import useAccountStore from '@/account/accountStore'
import { usePrimaryAccount } from '@/account/usePrimaryAccount'
import { resolveHomeRouteForContext } from '@/common/navigation/accountRoutes'
import { useRewardsData } from './model/useRewardsData'
import { RewardsLoadingState } from './components/RewardsLoadingState'
import { RewardsEmptyState } from './components/RewardsEmptyState'
import { RewardsList } from './components/RewardsList'

const RewardsPage: React.FC = () => {
    const navigate = useNavigate()
    const activeAccountId = useAccountStore((s) => s.activeAccountId)
    const primaryAccount = usePrimaryAccount()
    const { rewards, isLoading, hasRewards, totalRewards } = useRewardsData()

    const handleBackToDashboard = () =>
        navigate(resolveHomeRouteForContext({ primaryAccount: primaryAccount ?? null, activeAccountId }))

    return (
        <>
            <Helmet>
                <title>
                    {REWARDS_COPY.pageTitle} | {APP.title}
                </title>
            </Helmet>
            <H1 className="mb-4 md:mb-8">{REWARDS_COPY.pageTitle}</H1>

            {isLoading ? (
                <RewardsLoadingState />
            ) : hasRewards ? (
                <RewardsList rewards={rewards} totalRewards={totalRewards} />
            ) : (
                <RewardsEmptyState onBackToDashboard={handleBackToDashboard} />
            )}
        </>
    )
}

export default React.memo(RewardsPage)
